import React, { useState, useContext, useEffect } from "react";
import { ITimeSlot } from "../../../models/order";
import { Dialog } from "../../Common/Dialog";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../stores/rootStore";
import { CollectionTimeSlotHeader } from "./CollectionTimeSlotHeader";
import { CollectionTimeSlotGrid } from "./CollectionTimeSlotGrid";

interface IProps {
  showDialog: boolean;
  hideDialog: () => void;
  setTimeSlot: (value: ITimeSlot) => void;
}
export const CollectionTimeSlotDialog: React.FC<IProps> = observer(
  ({ showDialog, hideDialog, setTimeSlot }) => {
    const [localTimeSlot, setLocalTimeSlot] = useState<ITimeSlot|undefined>();
    const [localSelectedDay, setLocalSelectedDay] = useState<Date|undefined>();
    const rootStore = useContext(RootStoreContext);
    const {
      defaultCollection,
      loadingCollectionSlots,
    } = rootStore.timeSlotStore;

    useEffect(() => {
      setLocalTimeSlot(defaultCollection);
    }, []);

    useEffect(()=>{
      if(localTimeSlot){
        setLocalSelectedDay(localTimeSlot.slotDate);
      }
    },[localTimeSlot])
    const saveTimeSlot = () => {
      setTimeSlot(localTimeSlot!);
      hideDialog();
    };

    const handleSelectDay = (day: Date) => {
      setLocalSelectedDay(day);
      setLocalTimeSlot(undefined);
    }
    return (
      <Dialog
        title="Collection Slots"
        showDialog={showDialog}
        hideDialog={hideDialog}
        saveData={saveTimeSlot}
        saveDisabled={!localSelectedDay || !localTimeSlot}
        hasScroll={true}
      >
        {(loadingCollectionSlots) ? (
          <div>
              <span className="input-error-big">Loading slot...</span>
            </div>
        ) : (
          <>
            <CollectionTimeSlotHeader selectedDay={localSelectedDay} setSelectedDay={handleSelectDay} />
            <CollectionTimeSlotGrid
              timeSlot={localTimeSlot!}
              day={localSelectedDay}
              setTimeSlot={setLocalTimeSlot}
            />
          </>
        ) }
      </Dialog>
    );
  }
);
